export enum BedStatus {
    Vacant = 1,
    Occupied = 2,
    Reserved = 3,
    UnderMaintenance = 4,
    UnderHousekeeping = 5,
    OutOfService = 6,
}